import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "opc_token";
const USER_KEY = "opc_user";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(USER_KEY);
        }
        return Promise.reject(err);
    },
);

export const auth = {
    saveSession(token, user) {
        localStorage.setItem(TOKEN_KEY, token);
        localStorage.setItem(USER_KEY, JSON.stringify(user));
    },
    getUser() {
        try {
            return JSON.parse(localStorage.getItem(USER_KEY) || "null");
        } catch {
            return null;
        }
    },
    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    },
    clear() {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
    },
};

// Currency formatting — supports NGN, KES, GHS, UGX, TZS, USD
const SYMBOLS = { NGN: "₦", KES: "KSh", GHS: "GH₵", UGX: "USh", TZS: "TSh", USD: "$" };

export { SYMBOLS as CURRENCY_SYMBOLS };

export function fmtCurrency(amount, currency = "NGN", opts = {}) {
    const symbol = SYMBOLS[currency] || "";
    const num = Number(amount || 0);
    const compact = opts.compact;
    if (compact && Math.abs(num) >= 1_000_000_000) return `${symbol}${(num / 1_000_000_000).toFixed(2)}B`;
    if (compact && Math.abs(num) >= 1_000_000) return `${symbol}${(num / 1_000_000).toFixed(2)}M`;
    if (compact && Math.abs(num) >= 1_000) return `${symbol}${(num / 1_000).toFixed(1)}K`;
    return `${symbol}${num.toLocaleString(undefined, { minimumFractionDigits: opts.minDecimals ?? 0, maximumFractionDigits: opts.maxDecimals ?? 2 })}`;
}

export function fmtDateRel(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        const diff = Date.now() - d.getTime();
        const mins = Math.floor(diff / 60000);
        if (mins < 1) return "just now";
        if (mins < 60) return `${mins}m ago`;
        const hrs = Math.floor(mins / 60);
        if (hrs < 24) return `${hrs}h ago`;
        const days = Math.floor(hrs / 24);
        if (days < 7) return `${days}d ago`;
        return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
    } catch {
        return "";
    }
}

export function fmtDate(iso) {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
    } catch {
        return iso;
    }
}

export function fmtTime(iso) {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
    } catch {
        return "";
    }
}
